export function TaxAmountAndPercentageFormatter(text: string): {
  amount: string;
  percentage: string;
} {
  if (!text) {
    return {
      amount: "",
      percentage: "",
    };
  }

  const re = /(.*)\((.*)\)/;

  const parsed = text.match(re);
  const amount = parsed ? parsed[1] : "";
  const percentage = parsed ? parsed[2] : "";

  return {
    amount: amount,
    percentage: percentage,
  };
}
